import { faGrid2 } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Collection } from '@sorare/core/src/atoms/icons/Collection';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { BodyM } from '@sorare/core/src/atoms/typography';
import {
  ANY_SPORT_MY_CARDS,
  ANY_SPORT_MY_CARDS_COLLECTIONS,
} from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { SegmentButton } from 'searchCards/Segment/ui';

const StyledTabBar = styled(TabBar)`
  &.fullWidth {
    --tab-padding-y: var(--unit);
  }
`;

export const CollectionNavigationSwitch = () => {
  const location = useLocation();
  const { generateSportContextPath } = useSportContext();
  const isCollection = location.pathname.includes(
    ANY_SPORT_MY_CARDS_COLLECTIONS
  );
  const isLaptopAndAbove = useIsLaptop();
  const { formatMessage } = useIntl();

  const myCardsPath = generateSportContextPath(ANY_SPORT_MY_CARDS);
  const collectionsPath = generateSportContextPath(
    ANY_SPORT_MY_CARDS_COLLECTIONS
  );

  if (isLaptopAndAbove) {
    return (
      <Horizontal>
        <SegmentButton
          to={myCardsPath}
          className={classNames({ checked: !isCollection })}
        >
          <FontAwesomeIcon icon={faGrid2} />
          <BodyM bold>
            <FormattedMessage {...navLabels.players} />
          </BodyM>
        </SegmentButton>
        <SegmentButton
          to={generateSportContextPath(ANY_SPORT_MY_CARDS_COLLECTIONS)}
          className={classNames({ checked: isCollection })}
        >
          <Collection />
          <BodyM bold>
            <FormattedMessage {...navLabels.collections} />
          </BodyM>
        </SegmentButton>
      </Horizontal>
    );
  }

  return (
    <StyledTabBar forceMobileLayout>
      <Tab to={myCardsPath}>
        <FontAwesomeIcon
          icon={faGrid2}
          title={formatMessage(navLabels.players)}
        />
      </Tab>
      <Tab to={collectionsPath}>
        <Collection title={formatMessage(navLabels.collections)} />
      </Tab>
    </StyledTabBar>
  );
};
